import { useRef, useEffect, DependencyList } from 'react'

export default function useClickOutside<T extends Element>(
  onClick: (e: MouseEvent) => void,
  deps?: DependencyList
) {
  const nodeRef = useRef<T>(null)

  // Handle the click event, and determine if it was within the target ref
  const handleClickAnywhere: (e: MouseEvent) => any = e => {
    if (e.target instanceof Element && nodeRef.current && nodeRef.current.contains(e.target)) {
      return
    }

    onClick(e)
  }

  // Listen to clicks anywhere in the document
  useEffect(() => {
    document.addEventListener('mousedown', handleClickAnywhere)

    return () => {
      document.removeEventListener('mousedown', handleClickAnywhere)
    }
  }, deps)

  return nodeRef
}
